export default "__VITE_ASSET__mo6MQWsh__"